<template>
  <div class="home">
    <!-- banner图部分 -->
    <el-carousel :interval="5000" arrow="always" class="home-banner">
      <el-carousel-item v-for="(item, index) in imgsrc" :key="index">
        <img :src="item" alt="" />
      </el-carousel-item>
    </el-carousel>
    <div></div>
    <!-- 公司简介 -->
    <div class="container clearfix">
      <p>公司简介</p>
      <div class="home-line"></div>
      <div class="brief clearfix">
        <div class="content-left fl"></div>
        <div class="content-right fr">
          <h2>斐宸数字科技(上海)有限公司</h2>
          <p>
            斐宸数字科技（上海）有限公司（原上海斐宸电子科技有限公司，以下简称
            “公司”）是一家集软件研发、硬件制造及运维服务于一体的高新技术企业。公司始终坚持核心技术自主研发和创新，长期在人工智能算法、物联网、云计算、大数据、虚拟化等技术上创新科研，打造了集“智慧管理、智慧环境、智慧安全、智慧生活、智慧服务”为一体的高度集成且互联互通的智联共享云平台。通过统一开放的接口和数据平台，公司将产品平台模块化并整合联动，以智能识别、数据融合、移动计算、云计算等大数据技术的研究应用为核心，构建各类“互联网+”解决方案。着力为教育行业、交通行业、大型企事业、各类社区工地提供专业且贴切满足客户需求的产品解决方案及运营服务。
          </p>
          <p>公司拥有自主研发生产多项软件著作权、专利及多系列核心硬件产品，以“智慧的架构、智慧的服务、智慧的管理、智慧的运维、智慧的感知”五大智慧设计，在行业内处于领先地位。以物联网平台、业务平台以及服务平台为基础，提供智慧校园、智慧物业、智慧工地、智慧政企、智慧医院等解决方案。</p>
          <p>公司在全国各地拥有多家代理商，已累计服务学校用户超3000所，为多所大型工地园区提供智能化建设方案，并持续为大型企事业单位提供长期服务。公司以高品质的产品，专业可靠的技术，完善的售后服务，为我们在行业中赢得了客户的广泛认可。公司的产品远销全国，其中在上海、江苏、浙江、安徽、山东、河北、广西、江西、陕西、辽宁等地区建立了长期合作供销商。</p>
          <router-link to="/about" class="look-more">查看更多</router-link>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="home-middle">
      <div class="container clearfix">
        <p>解决方案</p>
        <div class="home-line"></div>
        <div class="home-mainbin">
          <ul>
            <li>
              <div class="mainbin-img fl">
                <img src="../../assets/img/home/business_Image_one.png" alt="" />
              </div>
              <div class="mainbin-text fr">
                <h2>智慧校园</h2>
                <p>斐宸智慧校园体系基于业务、数据双中台理念，建立共享开放能力平台，实现能力开放和服 务与数据的全生命周期治理；基于一云多端，混合云服务模式，覆盖管理、生活、教学、科研 和社会化服务全场景，让师生随时随地获得资源和服务；围绕按主题建设，按场景上线，以评 促建，可持续发展的路径，渐进建设全业务应用场景，让智慧校园建设更简单。</p>
                <router-link to="/solution" class="look-more">查看更多</router-link>
              </div>
            </li>
            <li>
              <div class="mainbin-text fl">
                <h2>智慧社区</h2>
                <p>斐宸智慧社区通过对辖区范围内的人员轨迹进行分析，对目标人员进行布控，实现对社区 内可 疑人员、可疑行为、可疑事件的及时发现和智能预警，可对海量多维度数据资源进行碰撞分析 和研判预警，实现多维数据查询和展示需求，将采集的多维度信息 汇聚，结合街道其它业务信 息形成数据资源仓库，对实时和历史信息进行快速的 检索、查询和综合分析、展示。</p>
                <router-link to="/solution" class="look-more">查看更多</router-link>
              </div>
              <div class="mainbin-img fr">
                <img src="../../assets/img/home/business_Image_three.png" alt="" />
              </div>
            </li>
            <li>
              <div class="mainbin-img fl">
                <img src="../../assets/img/home/gd_image.png" alt="" />
              </div>
              <div class="mainbin-text fr">
                <h2>智慧工地</h2>
                <p>
                  斐宸“互联网+”智慧工地，是将互联网+的理念和技术引入建筑工地，从施工现场源头抓起， 最大程度的收集人员、安全、环境、材料等关键业务数据，依托物联网、互联网，建立云端大 数据管理平台，形成“端+云+大数据”的业务体系和新的管理模式，打通从一线操作与远程 监管的数据链条，实现劳务、安全、环境、材料各业务环节的智能化、互联网化管理，提升建
                  筑工地的精益生产管理水平。实现“互联网+”与建筑工地的跨界融合，促进行业转型升级。
                </p>
                <router-link to="/solution" class="look-more">查看更多</router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 应用案例 -->
    <div class="container">
      <p>应用案例</p>
      <div class="home-line"></div>
      <div class="viewmore"><router-link to="/case">查看更多</router-link></div>
      <div class="home-recdyc">
        <ul>
          <li>
            <div>
              <p>盐城生物工程高等职业学校</p>
            </div>
          </li>
          <li>
            <div>
              <p>盐城技师学院</p>
            </div>
          </li>
          <li>
            <div>
              <p>上海工商职业技术学院</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 近期动态 -->
    <div class="container clearfix">
      <p>近期动态</p>
      <div class="home-line"></div>
      <router-link to="/news" class="viewmore">查看更多</router-link>
      <div class="dynamic clearfix">
        <div class="dynamic-img fl"></div>
        <div class="dynamic-text fr">
          <h2>圆满落幕！斐宸科技连云港东海森林温泉年终会议！</h2>
          <p>1月22日，斐宸科技全体员工在连云港东海森林温泉酒店团建举行年终总结会议！</p>
          <div>2022-01-23 公司新闻</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Home',
  data() {
    return {
      imgsrc: { url1: require('../../assets/img/home/background_Image.png'), url2: require('../../assets/img/home/background_Image_1.png'), url3: require('../../assets/img/home/background_Image.png') },
    };
  },
};
</script>
<style lang="less" scoped>
.home-banner {
  // margin-top: -60px;
  width: 100%;
  height: 594px;
  background: #0076de;
}
/deep/.el-carousel__container {
  height: 100%;
}
.home-banner img {
  width: 100%;
  height: 100%;
}
.container {
  position: relative;
}
.container > p {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  font-size: 60px;
  margin-top: 100px;
}
.home-line {
  width: 200px;
  margin: 0 auto;
  height: 6px;
  background: #0076de;
  margin-top: 7px;
  margin-bottom: 100px;
}
.content-left {
  width: 570px;
  height: 420px;
  background: url(../../assets/img/home/brief_introduction_Image.png) no-repeat center;
}
.content-right {
  width: 602px;
  height: 420px;
}
.content-right h2 {
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.content-right p {
  width: 100%;
  line-height: 1.6;
  font-size: 14px;
  font-weight: 400;
  text-indent: 2em;
  color: #666;
}
.content-right .look-more {
  margin-top: 12px;
}
.look-more {
  display: inline-block;
  padding: 10px 15px;
  color: #fff;
  font-weight: 400;
  font-size: 18px;
  background-color: #0076de;
  border-radius: 4px;
}
.viewmore {
  position: absolute;
  right: 0;
  top: 32px;
  font-size: 24px;
  font-weight: 400;
  color: #999;
}
.viewmore a {
  font-size: 24px;
  font-weight: 400;
  color: #999;
}
.home-middle {
  width: 100%;
  height: 100%;
  background: url(../../assets/img/home/middle_background.png);
}
.home-mainbin {
  margin-bottom: 100px;
}
.home-mainbin li {
  width: 100%;
  height: 290px;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 10px;
}
.home-mainbin li .mainbin-img {
  width: 510px;
  height: 100%;
}
.mainbin-text {
  width: 690px;
  height: 100%;
  padding: 30px 40px;
}
.mainbin-text.fl {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.mainbin-text.fr {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.mainbin-text h2 {
  margin-bottom: 30px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.mainbin-text p {
  margin-bottom: 46px;
  height: 86px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  color: #666;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
}
.home-recdyc {
  margin-bottom: 185px;
  width: 1200px;
  display: table;
  margin-left: auto;
  margin-right: auto;
}
.home-recdyc ul {
  display: table;
  margin-right: -45px;
}
.home-recdyc ul li {
  position: relative;
  float: left;
  width: 370px;
  height: 296px;
  margin-right: 45px;
  background-color: #000;
  border-radius: 10px;
}
.home-recdyc ul li:nth-child(1) > div {
  height: 100%;
  background: url(../../assets/img/home/case_one.png);
}
.home-recdyc ul li:nth-child(2) > div {
  height: 100%;
  background: url(../../assets/img/home/case_two.png);
}
.home-recdyc ul li:nth-child(3) > div {
  height: 100%;
  background: url(../../assets/img/home/case_three.png);
}
.home-recdyc ul li p {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  white-space: nowrap;
}
.dynamic {
  margin-bottom: 100px;
}
.dynamic-img {
  width: 570px;
  height: 310px;
  background: url(../../assets/img/home/dynamic_Image.png);
}
.dynamic-text {
  width: 572px;
  height: 310px;
}
.dynamic-text h2 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.dynamic-text p {
  margin-top: 95px;
  margin-bottom: 100px;
  font-size: 18px;
  line-height: 1.7;
  font-weight: 400;
  color: #666;
}
.dynamic-text div {
  font-size: 18px;
  font-weight: 400;
  color: #ccc;
}
</style>
